import React from 'react'
export const colorMap = {
  green: 'color-green',
  yellow: 'color-orange',
  red: 'color-red',
}

export const symbolMap = {
  green: <span className="fa fa-check" aria-hidden="true" />,
  yellow: <span className="fa fa-exclamation" aria-hidden="true" />,
  red: <span className="fa fa-times" aria-hidden="true" />,
}

export const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

// feedbackContent and connectionBullet need translation
export const feedbackContent = (intl) => ({
  red: {
    title_text: intl.formatMessage({
      id: 'aspire.personalInformationFeedback.needsWorkTitle',
      defaultMessage: 'Needs Work!',
    }),
    body: (
      <p>
        {intl.formatMessage({
          id: 'aspire.personalInformationFeedback.needsWorkBody',
          defaultMessage: 'Consider the feedback to improve this section.',
        })}
      </p>
      
    ),
  },
  yellow: {
    title_text: intl.formatMessage({
      id: 'aspire.personalInformationFeedback.onTrackTitle',
      defaultMessage: 'On Track!',
    }),
    body: (
      <p>
        {intl.formatMessage({
          id: 'aspire.personalInformationFeedback.onTrackBody',
          defaultMessage: 'Consider the feedback to improve this section.',
        })}
      </p>
    ),
  },
  green: {
    title_text: intl.formatMessage({
      id: 'aspire.personalInformationFeedback.goodJobTitle',
      defaultMessage: 'Good Job!',
    }),
    body: (
      <p>
        {intl.formatMessage({
          id: 'aspire.personalInformationFeedback.goodJobBody',
          defaultMessage: 'You have done a good job with this section!',
        })}
      </p>
    ),
  },
})

export const connectionBullet = (intl) => [
  intl.formatMessage({
    id: 'aspire.personalInformationFeedback.growNetwork',
    defaultMessage: 'Grow your network to 500+ professional connections',
  }),
  intl.formatMessage({
    id: 'aspire.personalInformationFeedback.buildEngagement',
    defaultMessage: 'Build engagement within your network',
  }),
]
